import React from 'react';
import { Modal, Backdrop, Fade, IconButton, Typography, makeStyles, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getAccountDetails } from '../../sessionStorage';
import { GetFormattedNumber } from '../Helpers/Formatters';
import './SupportModal.scss';

const useStyles = makeStyles(theme => ({
  modalContent: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  closeButton: {
    color: theme.palette.white.main,
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  header: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white.main,
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  contactContainer: {
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  teamName: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  contactLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const SupportModal = ({ open, handleClose }) => {
  const classes = useStyles();

  const accountDetails = getAccountDetails();

  const contactDetailsList = [
    {
      name: 'Sales Team',
      email: accountDetails.stEmail,
      contact: GetFormattedNumber(accountDetails.stPhone),
    },
    {
      name: 'Application Team',
      email: accountDetails.atEmail,
      contact: GetFormattedNumber(accountDetails.atPhone),
    },
    {
      name: 'Case Management Team',
      email: accountDetails.cmtEmail,
      contact: GetFormattedNumber(accountDetails.cmtPhone),
    },
    {
      name: 'Covr Technical Support',
      email: accountDetails.platformSupportEmail,
    },
  ];

  return (
    <Modal
      aria-labelledby="support-modal-title"
      aria-describedby="support-modal-description"
      className='d-flex align-items-center justify-content-center'
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box className={`${classes.modalContent} modal-content`}>
          <IconButton aria-label="close" className={`${classes.closeButton} position-absolute`} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <Box className={classes.header} display="flex" alignItems="center">
            <img alt="Covr Logo" src={`${process.env.PUBLIC_URL}/AdvisorImages/covr-logo-white.svg`} />
            <Typography variant="h5" className='ml-5 font-weight-normal'>Contact Covr</Typography>
          </Box>
          <Box className={classes.contactContainer} display='grid' gridTemplateColumns='1fr 1fr 1.5fr'>
            <Typography />
            <Typography variant="body1" className="text-center"><b>Phone</b></Typography>
            <Typography variant="body1" className="text-center"><b>Email</b></Typography>
            {contactDetailsList.map((team, index) => (
              <React.Fragment key={index}>
                <Typography variant="body1" className={classes.teamName}>{team.name}</Typography>
                <span className='text-center'><a className={classes.contactLink} href={`tel:${team.contact}`}>{team.contact}</a></span>
                <span><a className={classes.contactLink} href={`mailto:${team.email}`}>{team.email}</a></span>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SupportModal;



// WEBPACK FOOTER //
// ./src/components/Layout/SupportModal.js